import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { pastMaintenancesReducer } from './PastMaintenances';
import { PastMaintenancesSagasListener } from './PastMaintenances/sagas';
import { registerMaintenanceReducer } from './RegisterMaintenance';
import { upcomingMaintenancesReducer } from './UpcomingMaintenances';

const sagaMiddleware = createSagaMiddleware();
const middleware = applyMiddleware(sagaMiddleware);

export const maintenanceStoreReducer = combineReducers({
  pastMaintenances: pastMaintenancesReducer,
  upcomingMaintenances: upcomingMaintenancesReducer,
  registerMaintenance: registerMaintenanceReducer,
});

export const maintenanceStore = createStore(maintenanceStoreReducer, undefined, compose(middleware));
[PastMaintenancesSagasListener].forEach(sagaMiddleware.run);

export type MaintenanceState = ReturnType<typeof maintenanceStoreReducer>;
